import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";

import {Button} from "@/components/Button/Button";
import {Title} from "@/components/Title/Title";
import {quicksandBold} from "@/GlobalStyle";

const RgpdStyled = styled.p`
  font-size: 1.25rem;
  color: ${({theme}) => theme.colors.darkPrimary};
  font-weight: 500;
  a {
    color: ${({theme}) => theme.colors.mediumSecondary};
    text-decoration: underline;
    ${quicksandBold}
    &:hover {
      cursor: pointer;
      color: ${({theme}) => theme.colors.darkSecondary};
    }
  }
`;

const ButtonContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
`;

export function Rgpd(): ReactElement {
  const navigate = useNavigate();
  return (
    <div>
      <Title title="Gestion des données personnelles" />

      <RgpdStyled>
        Vos données personnelles, dont votre adresse e‑mail professionnelle,
        sont utilisées pour la gestion de nos notifications dans le cadre du
        programme COACT. Vous pouvez à tout moment vous opposer à cette
        utilisation ou demander l’effacement de votre adresse e‑mail de notre
        application COACT. Pour exercer vos droits, écrivez‑nous à l’adresse
        suivante : <a href="mailto:rgpd@cofaq.fr">rgpd@cofaq.fr</a>
      </RgpdStyled>
      <ButtonContainerStyled>
        <Button
          label="Retour sur la page d'accueil"
          onClick={() => navigate("/")}
        />
      </ButtonContainerStyled>
    </div>
  );
}
